//use this when creating a DOM parser is not an option...
export const stripHtmlStrings = (str): string => {
    if (str === undefined || str === null || str === ``) return ``;
    else str = str.toString();
    return str.replace(/(<([^>]+)>)/gi, ``).trim();
};

export const stripHTMLremovePtag = (str): string => {
    if (str === undefined || str === null || str === ``) return ``;
    else str = str.toString();
    return str.replace(/<\/?p[^>]*>/g, ``).trim();
};
